  <template>
  <quick-entry-complete>
    <template #contents>
      <v-col>
      <v-sheet
          :outlined="$vuetify.breakpoint.mdAndUp"
          max-width="840px"
          class="mx-auto py-md-10 mt-md-12"
      >
        <v-row class="px-md-10 pt-md-4">
          会員登録と買取お申込みが完了いたしました！<br>
          お手続き、誠にありがとうございました。<br>
          <br>
          次回からのお申込みでは、住所などのご入力は不要で、箱数・集荷日時の指定だけでお申し込みいただけます。<br>
          <br>
          また、買取の進行状況はマイページからご確認いただけます。
        </v-row>
        <v-row justify="center" class="pt-3 pt-md-6 pb-12">
          <v-btn
              class="secondary white--text text-subtitle-1 text-md-h6"
              :width="$vuetify.breakpoint.mdAndUp ? '500px' : '328px'"
              :height="$vuetify.breakpoint.mdAndUp ? '76px' : '48px'"
              href="/sell/situation"
          >
            マイページを確認する
          </v-btn>
        </v-row>
        <v-row class="pb-7 pb-md-4 px-md-10">
          買取の完了後は、受け取った本を様々な読み手に届け、活用してまいります。<br>
          どうぞ引き続き、よろしくお願いいたします。
        </v-row>
      </v-sheet>
      <v-row>
        <v-sheet
            v-if="requireIdentityUploading"
            :width="$vuetify.breakpoint.mdAndUp ? '840px' : ''"
            class="mx-auto py-md-6 mt-6 mt-md-12"
            :class="{'accent2': $vuetify.breakpoint.mdAndUp}"
            :outlined="!$vuetify.breakpoint.mdAndUp"
            :style="!$vuetify.breakpoint.mdAndUp ? `border: solid 1px ${$vuetify.theme.themes.light.secondary}`: ''"
        >
          <v-row class="ma-6">
            <v-row class="text-md-h5 text-subtitle-1" justify-md="center">
              本人確認について
            </v-row>
            <v-row class="px-md-10 pt-3 py-md-4">
              古物営業法により、インターネットを利用した非対面での古物の買取を行う場合、買取金額を振り込ませていただく前に、お客さまのご住所・氏名が正しいかどうか確認を行うことが義務付けられております。<br>
              下記のいずれかをご登録ください。
            </v-row>
            <v-row class="px-md-10 pt-2 pb-4 white--text" no-gutters>
              <v-col
                  cols="12"
                  md="4"
                  v-for="id in identities"
                  :key="id"
              >
                <v-card
                    rounded="0"
                    elevation="0"
                    :height="$vuetify.breakpoint.mdAndUp ? '' : '24px'"
                    class="mx-1 mt-2"
                >
                  <v-card-text
                      class="py-md-3 text-md-center"
                      :class="{
                                                      'primaryTextColor--text': !$vuetify.breakpoint.mdAndUp,
                                                      'white--text': $vuetify.breakpoint.mdAndUp,
                                                  }"
                      :style="$vuetify.breakpoint.mdAndUp ? 'background-color: #999' : ''"
                  >
                    {{ id }}
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row justify="center" class="mt-6">
              <v-btn
                  class="secondary white--text text-subtitle-1"
                  :width="$vuetify.breakpoint.mdAndUp ? '300px' : '328px'"
                  :height="$vuetify.breakpoint.mdAndUp ? '62px' : '48px'"
                  href="/identity/upload"
              >
                身分証をアップロードする
              </v-btn>
            </v-row>
          </v-row>
        </v-sheet>
      </v-row>
      <v-row>
        <v-sheet
            :width="$vuetify.breakpoint.mdAndUp ? '840px' : ''"
            class="mx-auto py-md-12 mt-6 mt-md-12"
            :class="{'accent2': $vuetify.breakpoint.mdAndUp}"
            :outlined="!$vuetify.breakpoint.mdAndUp"
            :style="!$vuetify.breakpoint.mdAndUp ? `border: solid 1px ${$vuetify.theme.themes.light.secondary}`: ''"
        >
          <v-row>
            <v-col class="ma-6 my-md-0">
              <v-row class="text-md-h5 text-subtitle-1" justify-md="center">
                お振込み口座の登録
              </v-row>
              <v-row class="px-md-10 pt-3 py-md-4">
                お申込みいただいたご本人名義の口座の登録をお願いいたします。
              </v-row>
              <v-row justify="center" class="mt-6">
                <v-btn
                    class="secondary white--text text-subtitle-1"
                    :width="$vuetify.breakpoint.mdAndUp ? '300px' : '328px'"
                    :height="$vuetify.breakpoint.mdAndUp ? '62px' : '48px'"
                    href="/bank/add"
                >
                  口座情報を登録する
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-sheet>
      </v-row>
    </v-col>
    </template>
  </quick-entry-complete>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import QuickEntryComplete from "../../organisms/buy/quick-entry-complete.vue"


export default {
  name: "quick-entry-vb-complete",
  components: {
    QuickEntryComplete,
  },
  data() {
    return {
      'identities': [
        '運転免許証',
        'パスポート',
        '写真付住民基本台帳カード',
        '国民年金手帳',
        '身体障害者手帳',
        '外国人登録証明書',
        '各種健康保険証',
      ],
      cdnUrl: VueConfig.cdn_url,
      requireIdentityUploading: false,
      isMemberRegisterGrantPoint: null,
    };
  },
  created() {
    this.isMemberRegisterGrantPoint = this.getMemberFormLabels.isMemberRegisterGrantPoint;
    this.requireIdentityUploading = this.getRequireIdentityUploading;
  },
  methods: {
    ...mapActions('member', ['updateFormLabels']),
  },
  computed: {
    ...mapGetters({
      getMemberFormLabels: 'member/getFormLabels',
      getRequireIdentityUploading: 'buy/getRequireIdentityUploading',
    }),
  },
}
</script>

  <style scoped lang="scss">
  ::v-deep .v-application--wrap {
    min-height: unset;
  }
  </style>